// extracted by mini-css-extract-plugin
export var addButton = "_o5-0";
export var border = "_o5-8";
export var check = "_o5-h";
export var danger = "_o5-6";
export var dropdownContainer = "_o5-1";
export var editModalBody = "_o5-j";
export var footerContainer = "_o5-i";
export var fullWidth = "_o5-a";
export var hide = "_o5-9";
export var icon = "_o5-3";
export var input = "_o5-7";
export var inputFlex = "_o5-b";
export var inputWrapper = "_o5-c";
export var manualFocus = "_o5-5";
export var optionButton = "_o5-4";
export var pillWrapper = "_o5-e";
export var pointer = "_o5-2";
export var showOverflow = "_o5-f";
export var tagsFlex = "_o5-d";
export var xButton = "_o5-g";